import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-info bg-white relative" }
const _hoisted_2 = { class: "body text-left" }
const _hoisted_3 = { class: "main-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold inline-block" }, "Informazioni sulla piattaforma", -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "changelog" }
const _hoisted_7 = { class: "block scroll-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SecondaryButton = _resolveComponent("SecondaryButton")!
  const _component_Vue3MarkdownIt = _resolveComponent("Vue3MarkdownIt")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.version)
            ? (_openBlock(), _createBlock(_component_SecondaryButton, {
                key: 0,
                class: "event-date text-primary block text-primary-600 bg-primary-50"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Versione: " + _toDisplayString(_ctx.version), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Vue3MarkdownIt, _mergeProps({
            class: "markdown-body reset-this",
            source: _ctx.changelog
          }, _ctx.options), null, 16, ["source"])
        ])
      ])
    ])
  ]))
}